import React, { useContext, useState } from 'react';
import {
  Typography,
  Dialog,
  Toolbar,
  IconButton,
  DialogContent,
  Button,
  Snackbar,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { DropzoneArea } from 'material-ui-dropzone';
import { useStateValue } from 'context/store';
import { message as closeMessage } from 'context/commons/actions';
import { I18nContext } from 'translations';
import { uploadFile } from 'utils/aws';
import { modalMessage, modalMessageHtml } from 'utils';
import { bulkEditUsers } from 'context/settings/users/actions';
import Loading from 'components/Loading';
import ModalBulkEditErrors from './ModalBulkEditErrors';

const ModalBulkEditUsers = ({ open, handleClose, getUsers }) => {
  const [fileUpload, setFileUpload] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openErrors, setOpenErrors] = useState(false);
  const [bulkErrors, setBulkErrors] = useState([]);
  const [updatedCount, setUpdatedCount] = useState(0);
  const { translate } = useContext(I18nContext);
  const [{ commons: { message } }, dispatch] = useStateValue();

  const handleFile = (files) => setFileUpload(files);

  const handleUpload = async () => {
    if (!fileUpload.length) return;
    setLoading(true);
    try {
      const date = Date.parse(new Date());
      const response = await uploadFile(fileUpload[0], `passengers_bulk_edit/${date}`);
      if (response) {
        const callback = await bulkEditUsers(dispatch, response.Location);
        if (callback && callback.status) {
          const hasErrors = callback.errors && callback.errors.length > 0;
          handleClose();
          if (hasErrors) {
            setBulkErrors(callback.errors);
            setUpdatedCount(callback.updated);
            modalMessageHtml(
              translate('app.settings.users.bulkEditErrors.title'),
              '',
              'warning',
              translate('app.settings.users.bulkEditErrors.seeErrors'),
              true,
              translate('close')
            ).then((result) => {
              if (result.isConfirmed) {
                setOpenErrors(true);
              } else {
                getUsers && getUsers(1);
              }
            });
          } else {
            modalMessage(
              translate('congratulations'),
              translate('app.settings.users.bulkEditSuccess'),
              'success',
              translate('accept'),
              true
            ).then(() => getUsers && getUsers(1));
          }
        }
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Dialog fullWidth maxWidth="sm" open={open} onClose={handleClose} style={{ zIndex: 9999 }}>
        <Toolbar style={{ justifyContent: 'center' }}>
          <IconButton
            edge="end"
            color="primary"
            onClick={handleClose}
            aria-label="close"
            style={{ position: 'absolute', right: 20, top: '10px' }}
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h5" color="textPrimary" className="text-center">
            {translate('app.settings.users.bulkEdit')}
          </Typography>
        </Toolbar>

        <DialogContent style={{ padding: '15px 30px 30px' }} className="text-center">
          {loading && <Loading />}
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, backgroundColor: '#f0f4ff', border: '1px solid #c7d7ff', borderRadius: 8, padding: '10px 14px', marginBottom: 14, textAlign: 'left' }}>
            <InfoOutlinedIcon style={{ fontSize: 16, color: '#4a6cf7', marginTop: 2, flexShrink: 0 }} />
            <Typography style={{ fontSize: '0.75rem', color: '#3a4e8c', lineHeight: 1.5 }}>
              {translate('app.settings.users.bulkEdit.phoneInfo')}
            </Typography>
          </div>
          <Button
            color="secondary"
            href="/templates/Template_Usuarios.xlsx"
            size="small"
            download
            style={{ marginBottom: 10 }}
          >
            {translate('app.bulkLoad.downloadFormatHere')}
          </Button>
          <DropzoneArea
            onChange={handleFile}
            acceptedFiles={['.xlsx', '.xls', '.csv']}
            maxFileSize={5000000}
            filesLimit={1}
            dropzoneText={translate('app.bulkLoad.dragFileHereOrClick')}
            getFileLimitExceedMessage={() => translate('app.bulkLoad.pleaseUploadOnlyOneFile')}
            getFileAddedMessage={(fileName) => `${fileName} ${translate('app.bulkLoad.successfullyAdded')}`}
            getFileRemovedMessage={(fileName) => `${fileName} ${'app.bulkLoad.removed'}`}
            getDropRejectMessage={() => translate('app.bulkLoad.unsupportedFileType')}
          />
          <br />
          <Button
            variant="contained"
            size="large"
            color="primary"
            onClick={handleUpload}
            disabled={loading || !fileUpload.length}
          >
            {translate('app.bulkLoad.uploadExcel')}
          </Button>
        </DialogContent>

        <Snackbar
          style={{ zIndex: 99999 }}
          open={!!message}
          autoHideDuration={6000}
          onClose={() => closeMessage(dispatch, null)}
          message={translate(message)}
        />
      </Dialog>

      <ModalBulkEditErrors
        open={openErrors}
        handleClose={() => { setOpenErrors(false); getUsers && getUsers(1); }}
        errors={bulkErrors}
        updated={updatedCount}
      />
    </>
  );
};

export default ModalBulkEditUsers;
